import { connect } from 'react-redux';
import { MenuButtonEditVideoEvents } from './events';
import { IMenuButtonEditVideoEvents, IMenuButtonEditVideoFields } from '../components/types';
import { MenuButtonEditVideo } from '../components/MenuButtonEditVideo';
import { IState } from '../../../../../store/types';
import { getCurrentVideoKey } from '../../../../../store/current-video/selectors';
import { getAuthUser } from '../../../../../store/general/selectors';
import { EAuthUserRole } from '../../../../../store/general/types';

const mapStateToProps = (
  dispatch: any
) => {
  return (
    state: IState
  ): IMenuButtonEditVideoFields => {
    return {
     show: getAuthUser(state)?.role === EAuthUserRole.ADMIN && !!getCurrentVideoKey(state)
    }
  };
}

const mapDispatchToProps = (
  dispatch: any
): IMenuButtonEditVideoEvents => ({
    onClick: () => dispatch(MenuButtonEditVideoEvents.onClick())
  }
);

export const MenuButtonEditVideoHOC = connect(
  mapStateToProps,
  mapDispatchToProps
)(MenuButtonEditVideo);

MenuButtonEditVideoHOC.displayName = 'MenuButtonEditVideoHOC';
